export default __webpack_public_path__ + "static/media/Bulk Inventory Upload.770652ad.xlsx";